(function () {
  'use strict';
  var STORAGE_KEY = 'cn_newsletter_shown';
  var CAP_DAYS = 7;

  function shouldShow() {
    try {
      var lastShown = localStorage.getItem(STORAGE_KEY);
      if (!lastShown) return true;
      var elapsed = Date.now() - parseInt(lastShown, 10);
      var capMs = CAP_DAYS * 24 * 60 * 60 * 1000;
      return elapsed > capMs;
    } catch (e) { return true; }
  }

  function markShown() {
    try { localStorage.setItem(STORAGE_KEY, Date.now().toString()); }
    catch (e) { /* localStorage unavailable */ }
  }

  function init() {
    var newsletterSections = document.querySelectorAll(
      '[data-cn-newsletter-popup]'
    );

    if (!shouldShow() && newsletterSections.length > 0) {
      newsletterSections.forEach(function(section) { section.style.display = 'none'; });
      return;
    }

    if (newsletterSections.length > 0) { markShown(); }

    document.addEventListener('submit', function(e) {
      var form = e.target.closest('.newsletter-form, form[action*="subscribe"]');
      if (form) { markShown(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
